





































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import DayCell from '@/components/attendance/DayCell.vue';
import { ICodeTable } from '@/models/Common';
import { IDayModel } from '@/models/AttendanceModels';
import * as types from '@/mutation-types';
import API from '@/Api';
import { constants } from 'fs';
import { connect } from 'http2';
import EmployeeDetail from './EmployeeDetail.vue';
import { Getter } from 'vuex-class';
const namespace: string = 'AppStore';

@Component({
    components: {
        DayCell,
    },
})
export default class Attendance extends Vue {
   @Getter('role', { namespace }) public userRole: any;
  @Getter('name', { namespace }) public userName: any;
    public headers: any[] = [
        {
          text: 'Sunday',
          align: 'right',
          sortable: false,
          value: 'sunday',
        },
        {
          text: 'Monday',
          align: 'right',
          sortable: false,
          value: 'monday',
        },
        {
          text: 'Tuesday',
          align: 'right',
          sortable: false,
          value: 'tuesday',
        },
         {
          text: 'Wednesday',
          align: 'right',
          sortable: false,
          value: 'wednesday',
        },
         {
          text: 'Thursday',
          align: 'right',
          sortable: false,
          value: 'thursday',
        },
        {
          text: 'Friday',
          align: 'right',
          sortable: false,
          value: 'friday',
        },
        {
          text: 'Saturday',
          align: 'right',
          sortable: false,
          value: 'saturday',
        },
        {
          text: 'Summary',
          align: 'right',
          sortable: false,
          value: 'summary',
        },
    ];
    public items: any[] = [];
    public lastSyncTime: string = '';
    public months: ICodeTable[] = [];
    public selectedMonth: any = {} as any;
    public title: string = '';
    public dialog: boolean = false;
    public infoDialog: boolean = false;
    public selectedItem: any = {}  as any;
    public regularizationTypes: ICodeTable[] = [];
    public regularizationType: ICodeTable = null as any;
    public reason: string = '';
    public disableButton: boolean = false;
    public clearCache: any = false;
    public employeid: string = '';
    
// old
//     public timeOptions: string[] = [
//   '07:00 AM', '08:00 AM', '09:00 AM', '10:00 AM', '11:00 AM',
//   '12:00 PM', '01:00 PM', '02:00 PM', '03:00 PM', '04:00 PM',
//   '05:00 PM', '06:00 PM', '07:00 PM', '08:00 PM', '09:00 PM',
//   '10:00 PM', '11:00 PM'
// ];
// old

public timeOptions: string[] = [
  '12:00 AM', '01:00 AM', '02:00 AM', '03:00 AM', '04:00 AM',
  '05:00 AM', '06:00 AM', '07:00 AM', '08:00 AM', '09:00 AM',
  '10:00 AM', '11:00 AM', '12:00 PM', '01:00 PM', '02:00 PM',
  '03:00 PM', '04:00 PM', '05:00 PM', '06:00 PM', '07:00 PM',
  '08:00 PM', '09:00 PM', '10:00 PM', '11:00 PM',
];

public fromTime: string = '';
public toTime: string = '';
 

    public load(calendarId: any) {
        const employeeId = this.$route.params.id ? this.$route.params.id : '';
        
        const url = window.location.href;
        const clearCache = url.split('=')[1];
        this.clearCache = clearCache === 'true' ? true : false;
        API.Instance
            .get(`/api/attendance?payrollCalendarId=${calendarId}&employeeRefId=${employeeId}&clearCache=${this.clearCache}`)
            .then((response) => {
                if (response.data.showInfoWindow && response.data.showInfoWindow === true) {
                  this.infoDialog = response.data.showInfoWindow;
                  
                } else {
                  this.items = response.data.items;
                  this.lastSyncTime = response.data.lastSyncTime;
                  this.title = response.data.title;
                  this.employeid = response.data.employeid;
                   
                }
        });
    }

    public created() {
       window.eventBus.$on(types.SHOW_REGULARIZATION_WINDOW, (item: IDayModel) => {
        console.log(item);
              this.selectedItem = item;
              let url = 'api/regularization-type?type=2';
              if (this.selectedItem && this.selectedItem.expectedWorkHour) {
                url += `&expectedWorkHour=${this.selectedItem.expectedWorkHour}`;
              }
              if (this.selectedItem && this.selectedItem.actualWorkHour) {
                url += `&actualWorkHour=${this.selectedItem.actualWorkHour}`;
              }
              if (this.selectedItem && this.selectedItem.caption) {
                url += `&caption=${this.selectedItem.caption}`;
              }
              if (this.selectedMonth) {
                url += `&calendarId=${this.selectedMonth}`;
              }
              if (this.$route.params.id) {
                url += `&empRefId=${this.$route.params.id}`;
              }
              API.Instance
              .get(url).then((response) => {
                this.regularizationTypes = response.data;
                this.dialog = true;
              });
            });
    }

    public mounted() {
        API.Instance.get('api/payroll-months').then((response) => {
            this.months = response.data;
            this.selectedMonth = this.months && this.months[0].id;
          
        });
    }
// old
//     get filteredToTimeOptions(): string[] {

//   const fromIndex = this.timeOptions.indexOf(this.fromTime);
//   return this.timeOptions.slice(fromIndex + 1);
// }
// old
get filteredToTimeOptions(): string[] {
  const fromIndex = this.timeOptions.indexOf(this.fromTime);
  if (fromIndex === -1) return [];

  // Times after fromTime (same day)
  const afterFrom = this.timeOptions.slice(fromIndex + 1);

  // For night shift: wrap around and include early morning options (next day)
  // We show times from 12:00 AM up to (but not including) fromTime
  const beforeFrom = this.timeOptions.slice(0, fromIndex);

  // Label wrapped times clearly so user knows they're next day
  const nextDayOptions = beforeFrom.map(t => `${t} (+1)`);

  return [...afterFrom, ...nextDayOptions];
}
// old
// private convertTo24Hour(time: string): string {
//   const [rawTime, modifier] = time.split(' ');
//   let [hours, minutes] = rawTime.split(':').map(Number);

//   if (modifier === 'PM' && hours < 12) {
//     hours += 12;
//   }
//   if (modifier === 'AM' && hours === 12) {
//     hours = 0;
//   }

//   return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
// }
// old

private convertTo24Hour(time: string): string {
  // Strip the "(+1)" next-day marker if present
  const cleanTime = time.replace(' (+1)', '').trim();

  const [rawTime, modifier] = cleanTime.split(' ');
  let [hours, minutes] = rawTime.split(':').map(Number);

  if (modifier === 'PM' && hours < 12) {
    hours += 12;
  }
  if (modifier === 'AM' && hours === 12) {
    hours = 0;
  }

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:00`;
}


    @Watch('selectedMonth') public onSelected(val: any) {
        if (this.selectedMonth) {
            this.load(this.selectedMonth);
        }
    }

   

public submitv1() {
  this.$validator.validateAll().then((response) => {
    if (this.$validator.errors.items.length === 0) {
      this.disableButton = true;

      const isWFH = this.regularizationType && this.regularizationType.id === 11;

      const payload: any = {
        typeId: this.regularizationType.id,
        date: this.selectedItem.date,
        expectedWorkHour: this.selectedItem.expectedWorkHour || null,
        actualWorkHour: this.selectedItem.actualWorkHour || null,
        status: this.selectedItem.status,
        calendarId: this.selectedMonth,
        inTime: isWFH ? this.convertTo24Hour(this.fromTime) : this.selectedItem.inTime,
        outTime: isWFH ? this.convertTo24Hour(this.toTime) : null,
        comment: this.reason,
        empRefId: this.$route.params.id ? this.$route.params.id : '',
      };

      API.Instance.post('api/attendance', payload).then(() => {
        this.reset();
        this.load(this.selectedMonth);
      }).finally(() => {
        this.disableButton = false;
      });
    }
  });
}

public submit() {
        this.$validator.validateAll().then((response) => {
           if (this.$validator.errors.items.length === 0) {
               this.disableButton = true;
               API.Instance
               .post('api/attendance', {
                   date: this.selectedItem.date,
                   expectedWorkHour: this.selectedItem.expectedWorkHour || null,
                   actualWorkHour: this.selectedItem.actualWorkHour || null,
                   typeId: this.regularizationType.id,
                   status: this.selectedItem.status,
                   calendarId: this.selectedMonth,
                   inTime: this.selectedItem.inTime,
                   comment: this.reason,
                   empRefId: this.$route.params.id ? this.$route.params.id : '',
                })
               .then((response2) => {
                    this.reset();
                    this.load(this.selectedMonth);
                    this.disableButton = false;
               });
           }
        });
    }



    public close() {
      this.reset();
    }

    public reset() {
      this.dialog = false;
      this.regularizationType = null as any;
      this.reason = '';
      this.$validator.reset();
    }
}
